import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChangeLangEventService } from './service/change-lang-event.service';
import { LanguageCode } from './data/laguage-code';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-language-nav-menu',
    templateUrl: './language-nav-menu.component.html',
    styleUrls: ['./language-nav-menu.component.scss'],
    standalone: false,
})
export class LanguageNavMenuComponent implements OnInit, OnDestroy {
    languages: LanguageCode[] = [LanguageCode.DE, LanguageCode.EN];
    setLanguage: LanguageCode = LanguageCode.DE;
    private changeLangSubscription: Subscription;
    langExpand = false;
    constructor(private changeLangEventService: ChangeLangEventService) {}

    ngOnInit(): void {
        this.changeLangSubscription = this.changeLangEventService
            .getChangeLang()
            .subscribe((languageCode) => {
                this.setLanguage = languageCode;
            });
    }

    ngOnDestroy(): void {
        this.changeLangSubscription.unsubscribe();
    }

    toogleExpandMenu() {
        this.langExpand = !this.langExpand;
    }

    changeLanguage(event: LanguageCode) {
        // Broadcast the language change
        // The subscription will automatically update this.setLanguage
        this.changeLangEventService.setLangSubject(event);
        this.toogleExpandMenu();
    }
}
